module.exports = __webpack_public_path__ + "assets/icon-rocket.anim.6dca9bef.svg";